import React from 'react';
export function PrivacyPolicyContent() {
  return <>
      <p className="mb-2.5" data-id="element-165">Last updated: January 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-166">
        1. Information We Collect
      </h3>
      <p className="mb-2.5" data-id="element-167">
        We collect information you provide directly to us when making a
        purchase, including name, email address, and payment information
        processed securely through our payment processor.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-168">
        2. Use of Information
      </h3>
      <p className="mb-2.5" data-id="element-169">
        We use your information exclusively to process your order, send the
        purchased digital materials, and for communications related to your
        purchase.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-170">
        3. Cookies and Tracking Technologies
      </h3>
      <p className="mb-2.5" data-id="element-171">
        We use cookies and the Meta Pixel to improve your experience and
        optimize our advertising campaigns. You can disable cookies in your
        browser settings.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-172">
        4. Sharing Information
      </h3>
      <p className="mb-2.5" data-id="element-173">
        We do not sell, trade, or transfer your personal information to outside
        parties, except those necessary to process your payment and deliver your
        order (payment processors and digital delivery platforms).
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-174">5. Security</h3>
      <p className="mb-2.5" data-id="element-175">
        We implement industry-standard security measures to protect your
        personal information. All transactions are processed with SSL
        encryption.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-176">6. Your Rights</h3>
      <p className="mb-2.5" data-id="element-177">
        You have the right to access, correct, or request the deletion of your
        personal information. To exercise these rights, you can contact us
        through our support platform.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-178">
        7. Changes to This Policy
      </h3>
      <p className="mb-2.5" data-id="element-179">
        We reserve the right to update this policy. Significant changes will be
        notified through our website.
      </p>
    </>;
}
export function TermsOfServiceContent() {
  return <>
      <p className="mb-2.5" data-id="element-180">Last updated: January 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-181">
        1. Acceptance of Terms
      </h3>
      <p className="mb-2.5" data-id="element-182">
        By purchasing any B.A.B.Y. 365 product, you agree to these terms of
        service in their entirety. If you do not agree with any of these terms,
        you should not use our products.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-183">
        2. Digital Products
      </h3>
      <p className="mb-2.5" data-id="element-184">
        All our products are digital downloads. You will receive immediate
        access via the email provided at purchase. No physical products are
        shipped.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-185">3. License of Use</h3>
      <p className="mb-2.5" data-id="element-186">
        By purchasing our products, you obtain a personal, non-transferable
        license for personal use only. Redistribution, sale, or sharing of the
        materials with third parties is strictly prohibited.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-187">4. Refund Policy</h3>
      <p className="mb-2.5" data-id="element-188">
        We offer a 30-day satisfaction guarantee. If you are not satisfied with
        your purchase, you can request a full refund within 30 days of purchase
        through our support platform.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-189">
        5. Intellectual Property
      </h3>
      <p className="mb-2.5" data-id="element-190">
        All B.A.B.Y. 365 content, including texts, images, designs, and
        methodologies, is protected by copyright. Reproduction without express
        authorization is prohibited.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-191">
        6. Limitation of Liability
      </h3>
      <p className="mb-2.5" data-id="element-192">
        B.A.B.Y. 365 provides educational information. We are not responsible
        for decisions made based on our content. Always consult health
        professionals for medical decisions.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-193">7. Modifications</h3>
      <p className="mb-2.5" data-id="element-194">
        We reserve the right to modify these terms at any time. Continued use of
        our products constitutes acceptance of the modified terms.
      </p>
    </>;
}
export function DisclaimerContent() {
  return <>
      <p className="mb-2.5" data-id="element-195">Last updated: January 2026</p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-196">
        Educational Purpose
      </h3>
      <p className="mb-2.5" data-id="element-197">
        All B.A.B.Y. 365 content, including the Main Protocol and the 4 Bonuses,
        is exclusively educational and informational in nature. It does not
        constitute medical advice, diagnosis, or treatment.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-198">
        Professional Consultation
      </h3>
      <p className="mb-2.5" data-id="element-199">
        Always consult with your pediatrician, family doctor, or other qualified
        health professional before implementing changes to your baby's routine,
        especially regarding sleep, feeding, or development.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-200">
        Results Not Guaranteed
      </h3>
      <p className="mb-2.5" data-id="element-201">
        The results mentioned on this site are individual experiences and are
        not typical or guaranteed. Every baby is unique and results will vary
        based on multiple factors including age, temperament, and consistency in
        application.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-202">Testimonials</h3>
      <p className="mb-2.5" data-id="element-203">
        The testimonials presented on this site are real user experiences but do
        not represent typical results. We do not guarantee that you will obtain
        the same results.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-204">Affiliation</h3>
      <p className="mb-2.5" data-id="element-205">
        This site is not affiliated, associated, authorized, endorsed by, or in
        any way officially connected with Meta Platforms Inc., Facebook™,
        Instagram™, WhatsApp™, or any other company mentioned on this site.
      </p>

      <h3 className="text-lg text-[#3D2B1F] mt-5 mb-2.5" data-id="element-206">
        Medical Emergencies
      </h3>
      <p className="mb-2.5" data-id="element-207">
        If your baby presents symptoms of a medical emergency, immediately call
        the emergency services in your country. Do not use this material as a
        substitute for emergency medical care.
      </p>
    </>;
}